export const PODCAST_REPORTING_ENABLED_MARKETS = Object.freeze([
  'at',
  'au',
  'be',
  'be-fr',
  'be-nl',
  'bg-bg',
  'bg-en',
  'cy',
  'cz',
  'de',
  'de-en',
  'dk',
  'dk-da',
  'dk-en',
  'ee',
  'ee-en',
  'ee-et',
  'es',
  'es-ca',
  'es-gl',
  'fi',
  'fr',
  'gr',
  'hr',
  'hr-en',
  'hr-hr',
  'hu',
  'ie',
  'in',
  'in-en',
  'in-hi',
  'it',
  'lt',
  'lt-en',
  'lt-lt',
  'lu',
  'lu-de',
  'lu-fr',
  'lv',
  'lv-en',
  'lv-lv',
  'mt',
  'nl',
  'nl-en',
  'nz',
  'ph',
  'ph-en',
  'ph-tl',
  'pl',
  'pt',
  'pt-en',
  'pt-pt',
  'ro',
  'ro-en',
  'ro-ro',
  'se',
  'si',
  'si-en',
  'si-sl',
  'sk',
  'sk-en',
  'sk-sk',
  'us',
  'us-es',
]);

// Music Videos reporting availability
export const MUSIC_VIDEOS_RELEASED_MARKETS = Object.freeze([
  'br',
  'br-en',
  'br-pt',
  'co',
  'co-en',
  'co-es',
  'eg',
  'eg-ar',
  'eg-en',
  'de',
  'de-en',
  'id',
  'id-en',
  'id-id',
  'it',
  'ke',
  'ke-en',
  'ke-sw',
  'nl',
  'nl-en',
  'ph',
  'ph-en',
  'ph-tl',
  'pl',
  'se',
  'uk',
]);

// Courses reporting availability
export const COURSES_RELEASED_MARKETS = Object.freeze(['uk']);

// Tracks reporting availability
export const TRACKS_RELEASED_MARKETS = Object.freeze([
  'au',
  'nz',
  'ca',
  'ca-en',
  'ca-fr',
  'se',
  'dk',
  'dk-da',
  'dk-en',
  'it',
  'es',
  'es-ca',
  'es-gl',
  'pt-en',
  'pt-pt',
  'pt',
]);
// Albums reporting availability
export const ALBUMS_RELEASED_MARKETS = Object.freeze([
  'au',
  'nz',
  'ca',
  'ca-en',
  'ca-fr',
  'se',
  'dk',
  'dk-da',
  'dk-en',
  'it',
  'es',
  'es-ca',
  'es-gl',
  'pt',
  'pt-en',
  'pt-pt',
]);

const isEnabledForCountry = (enabledCountryIsoCodeKeys: readonly string[]) => (userCountryIsoCode: string) =>
  new Set(enabledCountryIsoCodeKeys).has(userCountryIsoCode);

export const isPodcastReportingEnabledForCountry = isEnabledForCountry(PODCAST_REPORTING_ENABLED_MARKETS);
export const isMusicVideosReportingEnabledForCountry = isEnabledForCountry(MUSIC_VIDEOS_RELEASED_MARKETS);
export const isCoursesReportingEnabledForCountry = isEnabledForCountry(COURSES_RELEASED_MARKETS);
export const isTracksReportingEnabledForCountry = isEnabledForCountry(TRACKS_RELEASED_MARKETS);
export const isAlbumsReportingEnabledForCountry = isEnabledForCountry(ALBUMS_RELEASED_MARKETS);
